import axios from 'axios';

// Configuración base de Axios
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '',
  timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 10000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Interceptor para peticiones
axiosInstance.interceptors.request.use(
  (config) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`🚀 API Request: ${config.method?.toUpperCase()} ${config.url}`);
      if (config.data) console.log('📦 Data:', config.data);
    }
    return config;
  },
  (error) => {
    console.error('❌ Error en interceptor de petición:', error);
    return Promise.reject(error);
  }
);

// Interceptor para respuestas
axiosInstance.interceptors.response.use(
  (response) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`✅ API Response: ${response.status} - ${response.config.url}`);
      console.log('📥 Response data:', response.data);
    }
    return response;
  },
  (error) => {
    if (process.env.NODE_ENV === 'development') {
      console.error(`❌ API Error: ${error.response?.status || 'Network Error'}`);
      console.error('Error details:', error.response?.data || error.message);
    }

    // Manejar errores comunes
    if (error.response) {
      const { status } = error.response;
      
      switch (status) {
        case 400:
          console.error('Bad Request - Datos inválidos');
          break;
        case 404:
          console.error('Not Found - Recurso no encontrado');
          break;
        case 500:
          console.error('Internal Server Error');
          break;
        default:
          console.error('Error desconocido');
      }
    } else if (error.request) {
      console.error('Error de red - No se recibió respuesta del servidor');
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;